/**
 * queue-hours — shared opening-hours vocabulary for queues (used by the
 * Queues list, the queue wizard and the seeds' shapes).
 */
import type { QueueHours } from "./queues-api";

export const Q_DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export function hmLabel12(hm: string): string {
  const [h, m] = hm.split(":").map((x) => parseInt(x, 10));
  const ap = h >= 12 ? "PM" : "AM";
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return m ? `${h12}:${String(m).padStart(2, "0")} ${ap}` : `${h12} ${ap}`;
}

export const TIME_OPTS: string[] = (() => {
  const out: string[] = [];
  for (let h = 6; h <= 22; h++) { out.push(`${String(h).padStart(2, "0")}:00`); if (h < 22) out.push(`${String(h).padStart(2, "0")}:30`); }
  return out;
})();

/** "Mon 10 AM–2 PM · Thu–Sat 9 AM–5 PM" — consecutive days with one window collapse to a range. */
export function qHoursLabel(hours: QueueHours[] | undefined): string {
  if (!hours || hours.length === 0) return "Follows location hours";
  return hours.map((h) => {
    if (!Array.isArray(h.days) || h.days.length === 0) return "—";
    const days = [...h.days].sort((a, b) => a - b);
    const parts: string[] = [];
    let s = 0;
    while (s < days.length) {
      let e = s;
      while (e + 1 < days.length && days[e + 1] === days[e] + 1) e++;
      parts.push(e > s ? `${Q_DAYS[days[s]]}–${Q_DAYS[days[e]]}` : Q_DAYS[days[s]]);
      s = e + 1;
    }
    return `${parts.join(", ")} ${hmLabel12(h.start)}–${hmLabel12(h.end)}`;
  }).join(" · ");
}
